/* eslint-disable max-len */
import Axios from 'axios';

const apiFactory = Axios.create({
    baseURL: 'https://api.o91.coding.al/api/v1/',
    headers: {
        'Content-Type': 'application/json',
    }
});


export default apiFactory;
